export const HostPayBadge = () => {
  return (
    <span className="typo-caption2 w-12 rounded-xs border border-gray-900 px-1 py-0.5 text-center font-medium select-none">
      정산완료
    </span>
  )
}
